<template>
  <div class='EnbAdm'>
    <global-spinner v-if="Loading"/>
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GlobalSpinner from '@/components/Spinner/GlobalSpinner'
export default {
  name: 'EnbAdm',
  components: { GlobalSpinner },
  computed: {
    ...mapGetters(['Loading'])
  }
}
</script>

<style scoped>
.EnbAdm {
  width: 100%;
  height: 100%;
}
</style>
